import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useShopDateFormat } from '../../hooks/useShopDateFormat';
import type { ChatMessage, ReminderPayload } from '../../api/types';

interface Props {
  message: ChatMessage;
}

/**
 * One `kind: 'reminder'` system message, rendered from its raw `payload`
 * rather than its server-rendered `body`: the "when" must be shown in the
 * SHOP's time zone (the same zone the calendar and the task list use), and
 * only the client knows the viewer's language for the surrounding chrome.
 * `body` is still the accessible fallback for a payload that predates a
 * field, so it renders when the payload has no title.
 */
const ReminderCard = ({ message }: Props) => {
  const { t } = useTranslation();
  const { date, dateTime } = useShopDateFormat();
  const payload = message.payload as Partial<ReminderPayload>;

  if (!payload.title || !payload.anchor_at) {
    return <div className="reminder-card"><span className="reminder-card__title">{message.body}</span></div>;
  }

  const when = payload.all_day ? date(payload.anchor_at) : dateTime(payload.anchor_at);

  return (
    <div className="reminder-card">
      <span className="reminder-card__title">{payload.title}</span>
      <span className="reminder-card__when">{when}</span>
      {payload.partner_name && <span className="reminder-card__partner">{payload.partner_name}</span>}
      {message.link_path && (
        <Link className="reminder-card__open" to={message.link_path}>{t('admin.reminders.open')}</Link>
      )}
    </div>
  );
};

export default ReminderCard;
